import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';
import { IState } from 'shared/store';

export const NEWBUILDING_PUSH_TO_CALL = 'newbuilding_push_to_call_desktop';
export const selectIsNewbuildingPushToCallEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return state.isPushToCallEnabled && isAbUseExperimentsActive(experiments, NEWBUILDING_PUSH_TO_CALL, 'enabled');
};
